import { AxiosError } from 'axios';
import { OnErrorProps } from '../service/ApiService';
import toastService from '../service/ToastService';
import { HTTPError } from '../static/Messages';
import { HTTP_RESPONSE_STATUS } from '@shared/static/Constants';

export type ValidationFailure = {
  message: string;
  messageCode: string;
};

export const legacyGetOnError = (rule: { [key: number]: number } = []): OnErrorProps => {
  let errCode: number | undefined;

  const doOnError = (e: AxiosError) => {
    errCode = e.response?.status;
  };

  const doReturn = () => {
    const index = Object.keys(rule).findIndex((key) => key === '' + errCode);
    return index >= 0 ? Promise.reject(Object.values(rule)[index]) : Promise.reject(errCode);
  };

  return {
    doOnError,
    doReturn,
  };
};

export const legacyPostPutOnError = (): OnErrorProps => {
  let errorStatusCode: number | undefined;
  let validations: Record<string, ValidationFailure>;

  const doOnError = (e: AxiosError) => {
    errorStatusCode = e.response?.status;
    if (errorStatusCode === HTTP_RESPONSE_STATUS.PRECONDITION_FAILED) {
      validations = e.response?.data as Record<string, ValidationFailure>;
    }
  };

  const doReturn = () => {
    if (validations) {
      return Promise.resolve(validations);
    }
    if (errorStatusCode && errorStatusCode === HTTP_RESPONSE_STATUS.FORBIDDEN) {
      toastService.popMessage({
        type: toastService.toastType.error,
        message: HTTPError.unauthorised,
        head: HTTPError.head,
      });
      return Promise.resolve();
    }
    if (errorStatusCode && errorStatusCode >= HTTP_RESPONSE_STATUS.INTERNAL_SERVER_ERROR) {
      toastService.popMessage({
        type: toastService.toastType.error,
        message: HTTPError.default,
        head: HTTPError.head,
      });
      return Promise.resolve();
    }
    return Promise.reject(errorStatusCode);
  };

  return {
    doOnError,
    doReturn,
  };
};
